import { jwtDecode } from 'jwt-decode'

interface AccessTokenClaims {
  ver?: string
  sub: string
  roles?: Array<string>
  aud?: string
  act?: {
    sub: string
  }
}

function isV2Token(decodedAccessToken: AccessTokenClaims): boolean {
  return decodedAccessToken.ver === '2.0'
}

export function extractTokenFields(accessToken: string | undefined): { agentId?: string, roles: Array<string> } {
  if (!accessToken) return { roles: [] }

  try {
    const decodedAccessToken = jwtDecode<AccessTokenClaims>(accessToken)
    return {
      agentId: isV2Token(decodedAccessToken) ? decodedAccessToken.act?.sub : decodedAccessToken.aud,
      roles: decodedAccessToken.roles ?? [],
    }
  } catch {
    // it means we don't have a valid token and was not possible to decode it
    return { roles: [] }
  }
}
